import { TemplateName, TemplateVariable } from "./types";
import { TierIIEmailTemplate } from "./tierIIEmailTemplate";
export class T2SRemediationEmailTemplate extends TierIIEmailTemplate {
    constructor() {
        super(...arguments);
        this.id = TemplateName.T2SRemediationEmail;
    }
    subject({ communication }) {
        const report = communication.tierIIReports[0];
        const facilityNames = this.getFacilityNames(communication.facilities);
        const prefix = report?.reportKind === "REVISION"
            ? "Tier II Revision"
            : "Tier II Submission";
        const shortReportingYear = this.getShortReportingYear(report?.reportingYear);
        const trackingSuffix = communication.trackingId
            ? ` [ref ${communication.trackingId}]`
            : "";
        return `[CORRECTED] ${prefix} - ${facilityNames} - RY${shortReportingYear}${trackingSuffix}`;
    }
    text({ communication }) {
        const variables = this.extractVariables({ communication });
        const companyName = variables[TemplateVariable.CompanyName];
        const listOfFacilityNames = variables[TemplateVariable.FacilityNames];
        return /* html */ `
  <p>To whom it may concern,</p>
  <br />
  <p>We recently identified a technical issue that caused incorrect Tier II data (specifically .t2s) files to be included with a previous submission on behalf of ${companyName}. We sincerely apologize for the error.</p>
  <br />
  <p>Please find the corrected t2s file attached for the following facility(ies):</p>
  <br />
  <p>
    ${listOfFacilityNames}
  </p>
  <br />
  <p>This corrected submission supersedes and replaces the previously submitted T2S file(s) for the facility(ies) listed above. All other submission materials (e.g., site plans, reports) remain unchanged.</p>
  <br />
  <p>If you have already processed the previous submission, please replace the Tier II data file with the corrected version attached to this email.</p>
  <br />
  <p>This report is filed by Encamp, Inc. on behalf of ${companyName}.</p>
  <br />
  <p>If you have any questions or need additional information, please reach out to us at 317-450-4557 or email support@encamp.com.</p>
  <br />
  <p>We appreciate your understanding and your continued efforts to keep our communities safe.</p>
  <br />
  <p>
    Best,
    <br />
    The Encamp Compliance Team
  </p>
`;
    }
}
//# sourceMappingURL=t2sRemediationEmailTemplate.js.map